<template>
  
  <div
    :class="{
      'form-control_required' : mustFilled,
      'form-control_text'     : type === 'text',
      'form-control_tel'      : type === 'tel',
      'form-control_email'    : type === 'email',
      'form-control_file'     : type === 'file',
      'form-control_checkbox' : type === 'checkbox',
      'form-control_select'   : type === 'select',
      'form-control_focused'  : focused,
      'form-control_filled'   : filled,
    }"
    class="form-control"
  >
  
    <label
      v-if="label !== null"
      :for="name"
      class="form-control__label"
    >{{ label }}</label>

    <slot
      name="before"
      :value="value"
    ></slot>

    <form-control-file
      v-if="type === 'file'"
      :name="name"
      @filled="onFilled"
      @value="onValue"
      class="form-control__el"
      :multiple="true"
    ></form-control-file>

    <form-control-checkbox
      v-else-if="type === 'checkbox'"
      :name="name"
      @filled="onFilled"
      class="form-control__el"
    ></form-control-checkbox>

    <form-control-select
      v-else-if="type === 'select'"
      :name="name"
      :options="options"
      @filled="onFilled"
      @focused="onFocused"
      @value="onValue"
      class="form-control__el"
    ></form-control-select>

    <form-control-text
      v-else
      :name="name"
      :type="type"
      @filled="onFilled"
      @focused="onFocused"
      @value="onValue"
      class="form-control__el"
    ></form-control-text>

  
    <slot name="after"></slot>

  </div>

</template>

<script>
  import FormControlCheckbox from '@/components/FormControlCheckbox';
  import FormControlFile from '@/components/FormControlFile';
  import FormControlText from '@/components/FormControlText';
  import FormControlSelect from '@/components/FormControlSelect';

  export default {
    name: 'FormControl',

    components: {
      FormControlCheckbox,
      FormControlFile,
      FormControlText,
      FormControlSelect,
    },

    props: {
      label: {
        type: String,
        default: null,
      },

      name: {
        type: String,
        required: true,
      },

      type: {
        type: String,
        default: 'text',
      },

      options: {
        type: Array,
      },

      required: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        focused: false,
        filled: false,
        mustFilled: false,
        value: null,
      };
    },

    methods: {
      onFilled(value) {
        this.filled = value;

        if (value && this.mustFilled) {
          this.mustFilled = false;
          this.$parent.$emit('fixed');
        }
      },

      onFocused(value) {
        this.focused = value;
      },

      onValue(value) {
        this.value = value;
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/FormControl.vue